<template>
  <div>
    <FormsTable />
  </div>
</template>

<script>
import FormsTable from '@/components/designer/FormsTable.vue';

export default {
  name: 'UserForms',
  components: {
    FormsTable,
  },
};
</script>
